export const accessToken = 'pk.eyJ1IjoiZ2VuZ3NodW5mZW5nIiwiYSI6ImNrbnljejYzeDE3d2UycG84a2UwODhxMzcifQ.anp-yl3ZXM4oY4sFuCtdmw'

export const style = {
    version: 8,
    sources: {
        'tianditu-img': {
            type: 'raster',
            tiles: [
                'https://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=26021ce819f1e96dc54f5a8fd06679b0'
            ],
            tileSize: 256
        },
        'tianditu-cva': {
            type: 'raster',
            tiles: [
                'https://t0.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=26021ce819f1e96dc54f5a8fd06679b0'
            ],
            tileSize: 256
        },
        'tianditu-ibo': {
            type: 'raster',
            tiles: [
                'https://t0.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=26021ce819f1e96dc54f5a8fd06679b0'
            ],
            tileSize: 256
        }
    },
    layers: [
        {
            id: 'vec',
            type: 'raster',
            source: 'tianditu-img',
            minzoom: 0,
            maxzoom: 18
        },
        {
            id: 'cva',
            type: 'raster',
            source: 'tianditu-cva',
            minzoom: 0,
            maxzoom: 18
        },
        {
            id: 'ibo',
            type: 'raster',
            source: 'tianditu-ibo',
            minzoom: 0,
            maxzoom: 18
        }
    ]
}